import { useRecipeService } from "../../Hooks/useRecipeService";
import { PageHeader } from "../../Shared/PageHeader";
import PageOverlay from "../../Shared/PageOverlay";
import { RecipeInfo } from "./Components/RecipeInfo";
import { RecipeViewActions } from "./Components/RecipeViewActions";
import YesNoModal from "../../Shared/YesNoModal";
import React, { useState, useEffect, Fragment } from "react";
import { Paper, Typography } from "@material-ui/core";
import queryString from "query-string";
import _ from "lodash";
import moment from "moment";

export function RecipeView(props) {
	const recipeService = useRecipeService(props.config);
	const [isLoading, setIsLoading] = useState(true);
	const [recipe, setRecipe] = useState({ name: "Loading Recipe...", placeholder: true });
	const [imageUrls, setImageUrls] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const queryStringValues = queryString.parse(props.location.search);
	var [scale, setScale] = useState(queryStringValues.scale);
	var [system, setSystem] = useState(queryStringValues.system);
	var [convertToMass, setConvertToMass] = useState(queryStringValues.convertToMass);

	useEffect(() => {
		const title = `View Recipe - ${props.config.appName}`;
		document.title = title;
		if (scale === "1") {
			setScale(null);
			return;
		}

		const qs = queryString.stringify(_.pickBy({ scale, system, convertToMass }));
		props.history.replace({ search: qs }); // update the URL QS

		setIsLoading(true);
		setImageUrls([]);
		recipeService.getRecipeById(props.match.params.recipeId, qs, (response) => {
			document.title = `${response.data.name} - ${props.config.appName}`;
			setRecipe(response.data);
			setIsLoading(false);
		}, (error) => {
			document.title = title;
			if (error?.response?.status === 404) {
				props.history.push("/notfound");
			}
		});

		recipeService.getImageIdsByRecipeId(props.match.params.recipeId, (response) => {
			setImageUrls((response.data.ImageIds || []).map(i => `${props.config.apiUrl}/Recipes/${props.match.params.recipeId}/Images/${i}`));
		}, (error) => {
		});
	}, [scale, system, convertToMass, props.match.params.recipeId, props.config.apiUrl]); // eslint-disable-line react-hooks/exhaustive-deps

	function confirmDeleteRequest() {
		setIsModalOpen(true);
	}

	function onNoModal() {
		setIsModalOpen(false);
	}

	function editRecipe() {
		props.history.push(`/recipes/${recipe.recipeId}/edit`);
	}

	function cloneRecipe() {
		props.history.push(`/recipes/${recipe.recipeId}/clone`);
	}

	function viewHistory() {
		props.history.push(`/recipes/${recipe.recipeId}/history`);
	}

	function onDeleteConfirmed() {
		setIsModalOpen(false);
		recipeService.deleteRecipe(recipe.recipeId, (response) => {
			if (response && response.status === 200) {
				props.history.push("/");
			} else {
				console.log(response);
			}
		}, (error) => {
			console.log(error);
			if (error.response) {
				console.log(error.response);
				if (error.response.status === 404) {
					props.history.push("/notfound");
				}
			}
		});
	}

	return (
		<React.Fragment>
			<PageHeader text={recipe.name} config={props.config} />
			<PageOverlay showOverlay={isLoading} />
			{!recipe.placeholder ?
				<Paper className="print-no-padding" style={{ padding: 12 }}>
					<RecipeInfo
						recipe={recipe}
						imageUrls={imageUrls}
						scale={scale}
						setScale={setScale}
						system={system}
						setSystem={setSystem}
						convertToMass={convertToMass}
						setConvertToMass={setConvertToMass} />

					<RecipeViewActions
						config={props.config}
						editRecipe={editRecipe}
						cloneRecipe={cloneRecipe}
						viewHistory={viewHistory}
						deleteRecipe={confirmDeleteRequest} />
				</Paper>
				: <Fragment />
			}
			<YesNoModal
				isOpen={isModalOpen}
				title="Delete Recipe"
				question={`Are you sure you want to delete ${recipe.name}?`}
				onYes={onDeleteConfirmed}
				onNo={onNoModal} />
			{!recipe.placeholder && recipe.updateDateTime ? (
				<Typography variant="subtitle2" color="textSecondary" style={{ whiteSpace: 'pre-line', marginTop: 8 }}>
					{`Last update: ${moment(recipe.updateDateTime).format("MMM D, YYYY h:mm:ss a")}\nLast updated by: ${recipe.updateUsername || 'Unknown'}`}
				</Typography>
			) : null}
		</React.Fragment >
	);
}
